/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminOrderListAndTrackingRouteRouteImport } from './routes/admin/order-list-and-tracking/route'
import { Route as AdminManagementRouteRouteImport } from './routes/admin/management/route'
import { Route as AdminOrderListAndTrackingIndexRouteImport } from './routes/admin/order-list-and-tracking/index'
import { Route as AdminManagementIndexRouteImport } from './routes/admin/management/index'
import { Route as AdminDashboardIndexRouteImport } from './routes/admin/dashboard/index'
import { Route as AdminManagementCustomersRouteImport } from './routes/admin/management/customers'
import { Route as AdminManagementRolesRouteRouteImport } from './routes/admin/management/roles/route'
import { Route as AdminManagementUsersIndexRouteImport } from './routes/admin/management/users/index'
import { Route as AdminManagementRolesIndexRouteImport } from './routes/admin/management/roles/index'
import { Route as AdminManagementUsersCreateRouteImport } from './routes/admin/management/users/create'
import { Route as AdminManagementUsersIdRouteImport } from './routes/admin/management/users/$id'
import { Route as AdminManagementRolesCreateRouteImport } from './routes/admin/management/roles/create'
import { Route as AdminManagementRolesIdRouteImport } from './routes/admin/management/roles/$id'

const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrderListAndTrackingRouteRoute =
  AdminOrderListAndTrackingRouteRouteImport.update({
    id: '/order-list-and-tracking',
    path: '/order-list-and-tracking',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminManagementRouteRoute = AdminManagementRouteRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOrderListAndTrackingIndexRoute =
  AdminOrderListAndTrackingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminOrderListAndTrackingRouteRoute,
  } as any)
const AdminManagementIndexRoute = AdminManagementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminManagementRouteRoute,
} as any)
const AdminDashboardIndexRoute = AdminDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminManagementCustomersRoute =
  AdminManagementCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AdminManagementRouteRoute,
  } as any)
const AdminManagementRolesRouteRoute =
  AdminManagementRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AdminManagementRouteRoute,
  } as any)
const AdminManagementUsersIndexRoute =
  AdminManagementUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AdminManagementRouteRoute,
  } as any)
const AdminManagementRolesIndexRoute =
  AdminManagementRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminManagementRolesRouteRoute,
  } as any)
const AdminManagementUsersCreateRoute =
  AdminManagementUsersCreateRouteImport.update({
    id: '/users/create',
    path: '/users/create',
    getParentRoute: () => AdminManagementRouteRoute,
  } as any)
const AdminManagementUsersIdRoute = AdminManagementUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AdminManagementRouteRoute,
} as any)
const AdminManagementRolesCreateRoute =
  AdminManagementRolesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AdminManagementRolesRouteRoute,
  } as any)
const AdminManagementRolesIdRoute = AdminManagementRolesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminManagementRolesRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/admin/management': typeof AdminManagementRouteRouteWithChildren
  '/admin/order-list-and-tracking': typeof AdminOrderListAndTrackingRouteRouteWithChildren
  '/admin/management/roles': typeof AdminManagementRolesRouteRouteWithChildren
  '/admin/management/customers': typeof AdminManagementCustomersRoute
  '/admin/dashboard': typeof AdminDashboardIndexRoute
  '/admin/management/': typeof AdminManagementIndexRoute
  '/admin/order-list-and-tracking/': typeof AdminOrderListAndTrackingIndexRoute
  '/admin/management/roles/$id': typeof AdminManagementRolesIdRoute
  '/admin/management/roles/create': typeof AdminManagementRolesCreateRoute
  '/admin/management/users/$id': typeof AdminManagementUsersIdRoute
  '/admin/management/users/create': typeof AdminManagementUsersCreateRoute
  '/admin/management/roles/': typeof AdminManagementRolesIndexRoute
  '/admin/management/users': typeof AdminManagementUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/admin/management/customers': typeof AdminManagementCustomersRoute
  '/admin/dashboard': typeof AdminDashboardIndexRoute
  '/admin/management': typeof AdminManagementIndexRoute
  '/admin/order-list-and-tracking': typeof AdminOrderListAndTrackingIndexRoute
  '/admin/management/roles/$id': typeof AdminManagementRolesIdRoute
  '/admin/management/roles/create': typeof AdminManagementRolesCreateRoute
  '/admin/management/users/$id': typeof AdminManagementUsersIdRoute
  '/admin/management/users/create': typeof AdminManagementUsersCreateRoute
  '/admin/management/roles': typeof AdminManagementRolesIndexRoute
  '/admin/management/users': typeof AdminManagementUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/admin/management': typeof AdminManagementRouteRouteWithChildren
  '/admin/order-list-and-tracking': typeof AdminOrderListAndTrackingRouteRouteWithChildren
  '/admin/management/roles': typeof AdminManagementRolesRouteRouteWithChildren
  '/admin/management/customers': typeof AdminManagementCustomersRoute
  '/admin/dashboard/': typeof AdminDashboardIndexRoute
  '/admin/management/': typeof AdminManagementIndexRoute
  '/admin/order-list-and-tracking/': typeof AdminOrderListAndTrackingIndexRoute
  '/admin/management/roles/$id': typeof AdminManagementRolesIdRoute
  '/admin/management/roles/create': typeof AdminManagementRolesCreateRoute
  '/admin/management/users/$id': typeof AdminManagementUsersIdRoute
  '/admin/management/users/create': typeof AdminManagementUsersCreateRoute
  '/admin/management/roles/': typeof AdminManagementRolesIndexRoute
  '/admin/management/users/': typeof AdminManagementUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/playground'
    | '/admin/management'
    | '/admin/order-list-and-tracking'
    | '/admin/management/roles'
    | '/admin/management/customers'
    | '/admin/dashboard'
    | '/admin/management/'
    | '/admin/order-list-and-tracking/'
    | '/admin/management/roles/$id'
    | '/admin/management/roles/create'
    | '/admin/management/users/$id'
    | '/admin/management/users/create'
    | '/admin/management/roles/'
    | '/admin/management/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/playground'
    | '/admin/management/customers'
    | '/admin/dashboard'
    | '/admin/management'
    | '/admin/order-list-and-tracking'
    | '/admin/management/roles/$id'
    | '/admin/management/roles/create'
    | '/admin/management/users/$id'
    | '/admin/management/users/create'
    | '/admin/management/roles'
    | '/admin/management/users'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/playground'
    | '/admin/management'
    | '/admin/order-list-and-tracking'
    | '/admin/management/roles'
    | '/admin/management/customers'
    | '/admin/dashboard/'
    | '/admin/management/'
    | '/admin/order-list-and-tracking/'
    | '/admin/management/roles/$id'
    | '/admin/management/roles/create'
    | '/admin/management/users/$id'
    | '/admin/management/users/create'
    | '/admin/management/roles/'
    | '/admin/management/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PlaygroundRoute: typeof PlaygroundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/order-list-and-tracking': {
      id: '/admin/order-list-and-tracking'
      path: '/order-list-and-tracking'
      fullPath: '/admin/order-list-and-tracking'
      preLoaderRoute: typeof AdminOrderListAndTrackingRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/management': {
      id: '/admin/management'
      path: '/management'
      fullPath: '/admin/management'
      preLoaderRoute: typeof AdminManagementRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/order-list-and-tracking/': {
      id: '/admin/order-list-and-tracking/'
      path: '/'
      fullPath: '/admin/order-list-and-tracking/'
      preLoaderRoute: typeof AdminOrderListAndTrackingIndexRouteImport
      parentRoute: typeof AdminOrderListAndTrackingRouteRoute
    }
    '/admin/management/': {
      id: '/admin/management/'
      path: '/'
      fullPath: '/admin/management/'
      preLoaderRoute: typeof AdminManagementIndexRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/dashboard/': {
      id: '/admin/dashboard/'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/management/customers': {
      id: '/admin/management/customers'
      path: '/customers'
      fullPath: '/admin/management/customers'
      preLoaderRoute: typeof AdminManagementCustomersRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/management/roles': {
      id: '/admin/management/roles'
      path: '/roles'
      fullPath: '/admin/management/roles'
      preLoaderRoute: typeof AdminManagementRolesRouteRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/management/users/': {
      id: '/admin/management/users/'
      path: '/users'
      fullPath: '/admin/management/users'
      preLoaderRoute: typeof AdminManagementUsersIndexRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/management/roles/': {
      id: '/admin/management/roles/'
      path: '/'
      fullPath: '/admin/management/roles/'
      preLoaderRoute: typeof AdminManagementRolesIndexRouteImport
      parentRoute: typeof AdminManagementRolesRouteRoute
    }
    '/admin/management/users/create': {
      id: '/admin/management/users/create'
      path: '/users/create'
      fullPath: '/admin/management/users/create'
      preLoaderRoute: typeof AdminManagementUsersCreateRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/management/users/$id': {
      id: '/admin/management/users/$id'
      path: '/users/$id'
      fullPath: '/admin/management/users/$id'
      preLoaderRoute: typeof AdminManagementUsersIdRouteImport
      parentRoute: typeof AdminManagementRouteRoute
    }
    '/admin/management/roles/create': {
      id: '/admin/management/roles/create'
      path: '/create'
      fullPath: '/admin/management/roles/create'
      preLoaderRoute: typeof AdminManagementRolesCreateRouteImport
      parentRoute: typeof AdminManagementRolesRouteRoute
    }
    '/admin/management/roles/$id': {
      id: '/admin/management/roles/$id'
      path: '/$id'
      fullPath: '/admin/management/roles/$id'
      preLoaderRoute: typeof AdminManagementRolesIdRouteImport
      parentRoute: typeof AdminManagementRolesRouteRoute
    }
  }
}

interface AdminManagementRolesRouteRouteChildren {
  AdminManagementRolesIdRoute: typeof AdminManagementRolesIdRoute
  AdminManagementRolesCreateRoute: typeof AdminManagementRolesCreateRoute
  AdminManagementRolesIndexRoute: typeof AdminManagementRolesIndexRoute
}

const AdminManagementRolesRouteRouteChildren: AdminManagementRolesRouteRouteChildren =
  {
    AdminManagementRolesIdRoute: AdminManagementRolesIdRoute,
    AdminManagementRolesCreateRoute: AdminManagementRolesCreateRoute,
    AdminManagementRolesIndexRoute: AdminManagementRolesIndexRoute,
  }

const AdminManagementRolesRouteRouteWithChildren =
  AdminManagementRolesRouteRoute._addFileChildren(
    AdminManagementRolesRouteRouteChildren,
  )

interface AdminManagementRouteRouteChildren {
  AdminManagementRolesRouteRoute: typeof AdminManagementRolesRouteRouteWithChildren
  AdminManagementCustomersRoute: typeof AdminManagementCustomersRoute
  AdminManagementIndexRoute: typeof AdminManagementIndexRoute
  AdminManagementUsersIdRoute: typeof AdminManagementUsersIdRoute
  AdminManagementUsersCreateRoute: typeof AdminManagementUsersCreateRoute
  AdminManagementUsersIndexRoute: typeof AdminManagementUsersIndexRoute
}

const AdminManagementRouteRouteChildren: AdminManagementRouteRouteChildren = {
  AdminManagementRolesRouteRoute: AdminManagementRolesRouteRouteWithChildren,
  AdminManagementCustomersRoute: AdminManagementCustomersRoute,
  AdminManagementIndexRoute: AdminManagementIndexRoute,
  AdminManagementUsersIdRoute: AdminManagementUsersIdRoute,
  AdminManagementUsersCreateRoute: AdminManagementUsersCreateRoute,
  AdminManagementUsersIndexRoute: AdminManagementUsersIndexRoute,
}

const AdminManagementRouteRouteWithChildren =
  AdminManagementRouteRoute._addFileChildren(AdminManagementRouteRouteChildren)

interface AdminOrderListAndTrackingRouteRouteChildren {
  AdminOrderListAndTrackingIndexRoute: typeof AdminOrderListAndTrackingIndexRoute
}

const AdminOrderListAndTrackingRouteRouteChildren: AdminOrderListAndTrackingRouteRouteChildren =
  {
    AdminOrderListAndTrackingIndexRoute: AdminOrderListAndTrackingIndexRoute,
  }

const AdminOrderListAndTrackingRouteRouteWithChildren =
  AdminOrderListAndTrackingRouteRoute._addFileChildren(
    AdminOrderListAndTrackingRouteRouteChildren,
  )

interface AdminRouteRouteChildren {
  AdminManagementRouteRoute: typeof AdminManagementRouteRouteWithChildren
  AdminOrderListAndTrackingRouteRoute: typeof AdminOrderListAndTrackingRouteRouteWithChildren
  AdminDashboardIndexRoute: typeof AdminDashboardIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminManagementRouteRoute: AdminManagementRouteRouteWithChildren,
  AdminOrderListAndTrackingRouteRoute:
    AdminOrderListAndTrackingRouteRouteWithChildren,
  AdminDashboardIndexRoute: AdminDashboardIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PlaygroundRoute: PlaygroundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
